<template>
  <div class="string">
    <div class="address-wrapper">
      <div class="fields custom mb-field">
        <div
          class="order-input address"
          :class="{
            'covid-address': isBuyout && !getDotIndex(dot),
            'admin-address': base.isAdmin,
          }"
        >
          <div
            class="label required icon-home"
            @click="chooseAddress"
            @keypress="chooseAddress"
          ></div>
          <AddressInput
            :placeholder="computedPlaceholder"
            :dot="dot"
            :locations="locations"
            :cityId="+order.city"
            :tokenGenerator="tokenGenerator"
            :draftSuggestions="draftSuggestions"
            ref="addressInput"
            @update:dot="updateDot({ dot, data: $event })"
            @handleDeleteDraftSuggestion="handleDeleteSuggestion"
            @handleDraftSuggestionClick="suggestion => handleSuggestionClick(suggestion, dot)"
            :rules="addressInputRules"
          >
            <template
              v-slot:suggestions
              v-if="
                !$refs.addressInput?.state.inputAddress.length &&
                getDotIndex(dot) + 1 == order.dots.length &&
                order.dots.length > 2 &&
                order.dots[0].address
              "
            >
              <div @click.prevent="setReturnDot" @keypress="setReturnDot" class="dropdown-item">
                <span class="item-address">
                  Возврат на: {{ order.dots[0].address }},
                  {{ order.dots[0].building }}
                </span>
              </div>
            </template>
          </AddressInput>
        </div>
        <div
          class="address-additions"
          v-if="dot.address && dot.isSuggestionSet && (!isBuyout || getDotIndex(dot))"
        >
          <div class="order-input entrance" :class="{ 'admin-field': base.isAdmin }">
            <input type="text" placeholder="Подъезд" v-model="entrance" ref="entranceField" />
          </div>
          <div class="order-input storey" :class="{ 'admin-field': base.isAdmin }">
            <input type="text" placeholder="Этаж" v-model="storey" ref="storeyField" />
          </div>
          <div class="order-input apartment" :class="{ 'admin-field': base.isAdmin }">
            <input
              type="text"
              placeholder="Кв./офис"
              v-model="apartment"
              @input="touchField('apartment')"
              :class="getErrorClass('apartment')"
              ref="apartmentField"
            />
          </div>
        </div>
      </div>
      <div
        class="invalid-text"
        v-if="dot.distanceFromMetro && base.isAdmin && !addressInputValidator?.$error"
        style="color: #000"
      >
        Дистанция от метро: {{ dot.distanceFromMetro.toFixed(0) }} м.
      </div>
      <ValidationView :error-messages="getErrorMessages('apartment')" :transition="false" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AddressInput from '@features/AddressInputWithValidation.vue'
import { GENERAL_STORE } from '../../store'
import addressMixin from '../../mixins/address'

export default {
  name: 'AddressComponent',
  components: { AddressInput },
  mixins: [addressMixin],
  computed: {
    ...mapState(GENERAL_STORE, ['tokenGenerator']),
  },
}
</script>
